<template>
  <div class="zakat-donation-wrapper">
    <!-- Zakat Donation Button -->
    <button 
      @click="openZakatModal" 
      :disabled="!zakatAmount || zakatAmount <= 0"
      :class="['zakat-donate-btn', { 'disabled': !zakatAmount || zakatAmount <= 0 }]"
    >
      {{ zakatAmount > 0 ? `Donate Zakat ($${zakatAmount.toFixed(2)})` : 'Calculate Zakat First' }}
    </button>

    <!-- Include the modal component -->
    <lifeline-donation-modal 
      :id="postId"
      :dstyle="1"
      @close="closeModal"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useDonationFormsStore } from '../store';

const store = useDonationFormsStore();

const props = defineProps({
  postId: {
    type: Number,
    default: 0
  },
  currency: {
    type: String,
    default: 'USD'
  }
});

const zakatAmount = ref(0);

// Watch for zakat amount updates from the calculator
const updateZakatAmount = () => {
  const zakatWrapper = document.querySelector('.lifeline-zakat-donation');
  if (zakatWrapper) {
    const amount = zakatWrapper.getAttribute('data-zakat-amount');
    if (amount) {
      zakatAmount.value = parseFloat(amount);
    }
  }
};

const openZakatModal = async () => {
  if (zakatAmount.value > 0) {
    // Initialize the donation store with Zakat data
    await store.getData({ 
      vm: { 
        id: props.postId,
        dstyle: 1
      } 
    });
    
    // Set Zakat-specific values
    store.amount = zakatAmount.value;
    store.extras.donation_purpose = 'Zakat';
    store.currency = props.currency;
    store.recurring = false; // Disable recurring for Zakat
    
    // Show the modal
    store.showModal = true;
  }
};

const closeModal = () => {
  store.showModal = false;
};

onMounted(() => {
  // Initial amount check
  updateZakatAmount();
  
  // Listen for zakat amount updates
  const observer = new MutationObserver(() => {
    updateZakatAmount();
  });
  
  const zakatWrapper = document.querySelector('.lifeline-zakat-donation');
  if (zakatWrapper) {
    observer.observe(zakatWrapper, {
      attributes: true,
      attributeFilter: ['data-zakat-amount']
    });
  }
});
</script>

<style scoped>
.zakat-donation-wrapper {
  display: inline-block;
}

.zakat-donate-btn {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.zakat-donate-btn:hover:not(.disabled) {
  background: linear-gradient(135deg, #218838, #1ea080);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.zakat-donate-btn.disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

.zakat-donate-btn:active:not(.disabled) {
  transform: translateY(0);
}
</style>